export const AVANGA_SAVED_ENTRIES_KEY = 'avanga-daily-log-entries';

export const SCHEDULE_TYPES = [
  {
    label: 'Work',
    value: 'WORK',
  },
  {
    label: 'Day off',
    value: 'DAY_OFF',
  },
  {
    label: 'Sick Leave',
    value: 'SICK_LEAVE',
  },
];
export const WORK_PLACES = [
  {
    label: 'WFH',
    value: 'HOME',
  },
  {
    label: 'WFO',
    value: 'OFFICE',
  },
];

export const CURRENT_STATUS_MAP = new Map([
  ['OFFICE', { label: 'Work', color: '#005b06' }],
  ['HOME', { label: 'Work from home', color: '#61a6cc' }],
  ['N/A', { label: 'N/A', color: '#000000' }],
]);

export const getScheduleTypeByValue = (value) => SCHEDULE_TYPES.find((type) => type.value === value);
export const getWhereByValue = (value) => WORK_PLACES.find((where) => where.value === value);
